import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import { flow, observable, runInAction } from "mobx";
import { realCommerceRequest } from "../utils";
import { RealCommerceError } from "../exceptions";
import { routeLocationAffiliateCouponDelete } from "@devowl-wp/api-real-commerce";
let AffiliateCoupon = (_class = class AffiliateCoupon {
  get session() {
    return this.store.store;
  }
  constructor(data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "busy", _descriptor2, this);
    this.store = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.delete = flow(function* () {
      this.busy = true;
      yield this.session.probablyRenewJwt();
      try {
        const {
          data: {
            id
          }
        } = this;
        yield realCommerceRequest({
          location: routeLocationAffiliateCouponDelete,
          request: {
            coupon: {
              id
            }
          },
          settings: {
            headers: this.session.authorizationHeader
          }
        });
        yield this.store.fetchCoupons();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busy = false;
      }
    });
    this.store = store;
    runInAction(() => {
      this.data = data;
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class);
export { AffiliateCoupon };